import React from 'react';
import { render } from 'react-dom';

import { errorCodes, getErrorMessageKey } from '../../util/errorCodes';
import jsonGet from '../../util/jsonGet';

import BookingPayment from '../react/BookingPayment';
import ErrorMessage from '../react/Core/ErrorMessage';
import Loading from '../react/Core/Loading';
import ProgressBar from '../react/ProgressBar';
import { DEFAULT_CRITICAL_BACKUP_CURRENCY } from '../../util/currency';
import { STORAGE_KEYS, getLocalStorage } from '../../util/storage';
import CUSTOM_EVENT from '../../util/customEvents';

export default class BookingPaymentRender {
  constructor(context) {
    this.context = context;
    this.init();
    this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    window.addEventListener(CUSTOM_EVENT.CURRENCY_CHANGE, this.handleCurrencyChange);
    // clean up is within index.jsx of BookingPayment
  }

  init(currentCurrency = null) {
    const {
      apiUrl: submitUrl,
      model,
      currentProgressBarStep,
      loadApi,
      title,
    } = this.context.dataset;
    if (!submitUrl || !model || !currentProgressBarStep || !loadApi)
      throw Error('Missing a required dataset');

    let labels;
    try {
      labels = JSON.parse(model);
    } catch (e) {
      labels = undefined;
      console.error('Error parsing labels json: ', model);
    }

    const urlSearchParams = new URLSearchParams(window.location.search);
    const orderId = urlSearchParams.get('OrderId') || urlSearchParams.get('orderId');
    const loadApiUrl = `${loadApi}/${orderId}`;

    // Normally we use getInitialCurrencyState function here to check if currency exists as an edge case
    // if a currency is removed, however here we don't have that information on a list from BE
    // so we must rely on local storage only with a backup of the critical currency
    const currentCurrencyCodeAndSymbol =
      currentCurrency ||
      getLocalStorage(STORAGE_KEYS.currentCurrency, DEFAULT_CRITICAL_BACKUP_CURRENCY);

    this.fetchData(
      loadApiUrl,
      currentCurrencyCodeAndSymbol,
      labels,
      title,
      currentProgressBarStep,
      orderId,
      submitUrl
    );
  }

  cleanup() {
    window.removeEventListener(CUSTOM_EVENT.CURRENCY_CHANGE, this.handleCurrencyChange);
  }

  fetchData(
    loadApiUrl,
    currentCurrencyCodeAndSymbol,
    labels,
    title,
    currentProgressBarStep,
    orderId,
    submitUrl
  ) {
    const { code: currencyCode, symbol: currencySymbol } = currentCurrencyCodeAndSymbol;
    const payload = { currency: currencyCode };

    jsonGet(loadApiUrl, payload, (response) => {
      if (response.errorCode) {
        if (response.errorCode === errorCodes.TourBookingTourHasReachedPaxCapLimit) {
          window.location.href = response.redirectUri;
        }
        const errorMessageKey = getErrorMessageKey(response.errorCode);
        return render(
          <ErrorMessage text={labels[errorMessageKey] || response.message} />,
          this.context
        );
      }

      return render(
        BookingPaymentRender.renderMain(
          response,
          labels,
          submitUrl,
          title,
          currentProgressBarStep,
          orderId,
          currencySymbol,
          this.cleanup
        ),
        this.context
      );
    });

    return render(
      BookingPaymentRender.renderMain(
        undefined,
        labels,
        submitUrl,
        title,
        currentProgressBarStep,
        orderId,
        currencySymbol,
        this.cleanup
      ),
      this.context
    );
  }

  handleCurrencyChange(event) {
    const newCurrencyCodeAndSymbol = event?.detail;
    if (newCurrencyCodeAndSymbol) {
      this.init(newCurrencyCodeAndSymbol);
    }
  }

  static renderMain(
    paymentLoadData,
    labels,
    submitUrl,
    title,
    selectedStep,
    orderId,
    currencySymbol,
    cleanup
  ) {
    const data = paymentLoadData;

    return (
      <>
        <ProgressBar steps={data?.progressBarSteps} selectedStep={selectedStep} orderId={orderId} />
        <div className="PageTitle">
          <h1 className="PageTitle_title">{title}</h1>
        </div>
        {data ? (
          <BookingPayment
            currencySymbol={currencySymbol}
            data={data}
            labels={labels}
            submitUrl={submitUrl}
            cleanup={cleanup}
            isBooking
          />
        ) : (
          <Loading />
        )}
      </>
    );
  }
}
